"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.coordinates = void 0;
exports.coordinates = [
    { x: 4.2, y: 27.3 },
    { x: 5.6, y: 26.8 },
    { x: 8.6, y: 28.8 },
    { x: 10, y: 28.8 },
    { x: 11, y: 29.7 },
    { x: 13.4, y: 29.2 },
    { x: 14.7, y: 27.1 },
    { x: 16.8, y: 28.2 },
    { x: 18.3, y: 27.8 },
    { x: 19, y: 29.4 },
    { x: 20.2, y: 28.8 },
    { x: 20.8, y: 30.7 },
    { x: 22.2, y: 29.7 },
    { x: 22.7, y: 30.2 },
    { x: 23.2, y: 29.2 },
    { x: 24.7, y: 29.2 },
    { x: 25.7, y: 28.2 },
    { x: 27.1, y: 28.3 },
    { x: 28.1, y: 26.3 },
    { x: 31, y: 29.2 },
    { x: 33, y: 28.8 },
    { x: 35.4, y: 29.7 },
    { x: 36.9, y: 28.2 },
    { x: 40.8, y: 28.3 },
    { x: 42.2, y: 26.8 },
    { x: 43.7, y: 27.3 },
    { x: 44.5, y: 28.9 },
    { x: 45.4, y: 29.2 },
    { x: 46.3, y: 30.2 },
    { x: 49.6, y: 29.2 },
    { x: 51.2, y: 29.3 },
    { x: 52.2, y: 30.6 },
    { x: 54.2, y: 29.5 },
    { x: 55.6, y: 30.2 },
    { x: 56.9, y: 30.4 },
    { x: 56.7, y: 30.6 },
    { x: 55.3, y: 30.4 },
    { x: 54.2, y: 29.8 },
    { x: 52.1, y: 30.9 },
    { x: 50.9, y: 29.6 },
    { x: 49.6, y: 29.4 },
    { x: 46.1, y: 30.7 },
    { x: 45, y: 29.6 },
    { x: 44.1, y: 29.3 },
    { x: 43.4, y: 27.9 },
    { x: 42.3, y: 27.9 },
    { x: 41.3, y: 29.2 },
    { x: 37.4, y: 29.2 },
    { x: 35.6, y: 31.5 },
    { x: 33.2, y: 29.7 },
    { x: 31.5, y: 30.7 },
    { x: 29.7, y: 30.4 },
    { x: 28.6, y: 28.8 },
    { x: 28.1, y: 29.8 },
    { x: 26.1, y: 30 },
    { x: 25.6, y: 30.6 },
    { x: 24.2, y: 30.7 },
    { x: 23.7, y: 32.7 },
    { x: 22.2, y: 32.2 },
    { x: 20.2, y: 33.2 },
    { x: 19.3, y: 31.2 },
    { x: 18.3, y: 31.7 },
    { x: 17.4, y: 30.2 },
    { x: 15.6, y: 29.9 },
    { x: 14.9, y: 31.2 },
    { x: 11.5, y: 32.2 },
    { x: 9.5, y: 31.7 },
    { x: 9, y: 31.2 },
    { x: 8.1, y: 31.7 },
    { x: 5.6, y: 29.7 },
    { x: 4.1, y: 30 },
];
